<template>
    <v-form v-model="valid" ref="form">
        <v-card width="100%" class="text-left mb-10 elevation-0 form_wrapper">
            <v-card-title class="headline primary white--text">How Did We Do?</v-card-title>
            <v-card-text class="grey--text text--darken-2 py-6 mx-0 px-0 survey">
                <div class="py-5 mx-0 d-block">
                    <div class="my-2 mx-0">1. How was the timeliness and delivery of SRG&apos;s product/services?</div>
                    <v-select
                        v-model="surveydata.timeliness"
                        :rules="[(v) => !!v || 'Timeliness and delivery is required']"
                        required
                        solo
                        class="ml-4"
                        color="primary darken-3"
                        label="Select one.."
                        :items="['Perfect', 'Pretty Good', 'Could have been better', 'Needs Improvement']"
                    >
                    </v-select>
                    <div v-if="surveydata.timeliness != ''" class="mb-2 ml-4">{{ surveydata.timeliness != '' && surveydata.timeliness == 'Perfect' ? text_timeliness_feedback.perfect : surveydata.timeliness != '' && surveydata.timeliness != 'Perfect' ? text_timeliness_feedback.improve : '' }}</div>
                    <v-textarea
                        v-if="surveydata.timeliness != ''"
                        v-model="surveydata.timeliness_feedback"
                        solo
                        rows="3"
                        row-height="10"
                        color="primary darken-3"
                        class="ml-4"
                    ></v-textarea>
                </div>

                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">2. How was SRG&apos;s level of communication, accessibility, professionalism and interaction?</div>
                    <v-select
                        v-model="surveydata.professionalism"
                        :rules="[(v) => !!v || 'Communication & professionalism is required']"
                        required
                        solo
                        class="ml-4"
                        color="primary darken-3"
                        label="Select one.."
                        :items="['Perfect', 'Pretty Good', 'Could have been better', 'Needs Improvement']"
                    >
                    </v-select>
                    <div v-if="surveydata.professionalism != ''" class="mb-2 ml-4">{{ surveydata.professionalism != '' && surveydata.professionalism == 'Perfect' ? text_professionalism_feedback.perfect : surveydata.professionalism != '' && surveydata.professionalism != 'Perfect' ? text_professionalism_feedback.improve : '' }}</div>
                    <v-textarea
                        v-if="surveydata.professionalism != ''"
                        v-model="surveydata.professionalism_feedback"
                        solo
                        rows="3"
                        row-height="10"
                        color="primary darken-3"
                        class="ml-4"
                    ></v-textarea>
                </div>

                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">3. Considering SRG&apos;s fees for your project, was it...</div>
                    <v-select
                        v-model="surveydata.fees"
                        :rules="[(v) => !!v || 'Value for fees is required']"
                        required
                        solo
                        class="ml-4 mb-9"
                        color="primary darken-3"
                        label="Select one.."
                        :items="['An exceptional value, worth more than you paid', 'A good value, worth what you paid', 'A poor value, worth less than you paid']"
                    >
                    </v-select>
                </div>

                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">4. Would you recommend SRG to colleagues and friends?</div>
                    <v-select
                        v-model="surveydata.recommend"
                        :rules="[(v) => !!v || 'Would you recommend SRG is required']"
                        required
                        solo
                        class="ml-4 mb-9"
                        color="primary darken-3"
                        label="Select one.."
                        :items="['Yes', 'No', 'Maybe']"
                    >
                    </v-select>
                </div>
                
                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">5. How did you learn about SRG?</div>
                    <v-select
                        v-model="surveydata.learn"
                        :rules="[(v) => !!v || 'How did you learn about SRG is required']"
                        required
                        solo
                        class="ml-4 mb-9"
                        color="primary darken-3"
                        label="Select one.."
                        :items="referral_list">
                    </v-select>
                </div>

                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">6. What service did we help you with?</div>
                    <v-select
                        v-model="surveydata.module_name"
                        :rules="[(v) => !!v || 'What service we helped you with is required']"
                        required
                        solo
                        class="ml-4 mb-9"
                        color="primary darken-3"
                        label="Select one.."
                        :items="service_modules"
                        @change="serviceTeam()">
                    </v-select>
                </div>                                    

                <div class="my-5 mx-0 d-block">
                    <div class="my-2 mx-0">7. Please provide your name.</div>
                    <v-text-field
                        v-model="surveydata.client_name"
                        :rules="[(v) => !!v || 'Full name is required']"
                        required
                        solo
                        class="ml-4 mb-9"
                        color="primary darken-3"
                        label="Full Name">
                    </v-text-field>
                </div>  

                <div class="mt-6 mx-0 d-block">
                    <div class="my-2 mx-0">8. Please share your thoughts, comments, or suggestions. We would love any testimonials you can provide or learn what we could have done to make your experience better. (optional)</div>
                    <v-textarea
                        v-model="surveydata.comments_feedback"
                        solo
                        rows="4"
                        row-height="10"
                        color="primary darken-3"
                        class="ml-4"
                    ></v-textarea>
                </div>

                <div class="mb-6 mx-0 d-block">
                    <v-checkbox
                        v-model="surveydata.permission"
                        color="primary"
                    >
                        <span slot="label" class="pt-4 grey--text text--darken-2">I give SRG permission to use my survey/testimonial on future SRG publications or website. (optional)</span>
                    </v-checkbox>
                </div>

                <div class="my-6 mx-0 d-block">
                    <v-checkbox
                        v-model="surveydata.reference"
                        color="primary"
                    >
                        <span slot="label" class="pt-4 grey--text text--darken-2">Would you be willing to act as a reference for us if someone wanted to learn first hand about your experiences? (optional)</span>
                    </v-checkbox>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="py-3 px-4 survey">
                <v-spacer></v-spacer>
                <v-btn 
                    @click="surveyAnswers" 
                    :class="{ red: !valid }"
                    elevation="2"
                    class="mr-3 primary white--text font-weight-medium">
                    Submit Survey
                </v-btn>
                <v-btn 
                    @click="clearSurvey" 
                    color="primary"
                    class=""
                    outlined>
                    Clear
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>


<script>
    export default {
        name: 'HowDidWeDo',

        props: {
            submitSurvey: Function,
            getServiceTeam: Function
        },

        data () {
            return {
                valid: false,
                surveyThanks: false,
                client_first_name: '',
                survey_team_images: [],
                
                show_timeliness_feedback: false,
                show_professionalism_feedback: false,
                text_timeliness_feedback: {
                    perfect: 'Please let us know what we did to earn a “Perfect” score for timeliness and delivery. (optional)',
                    improve: 'Please let us know how we can improve our timeliness and delivery to receive a “Perfect” score. (optional)'
                },
                text_professionalism_feedback: {
                    perfect: 'Please let us know what we did to earn a “Perfect” score for communication, accessibility, professionalism and interaction. (optional)',
                    improve: 'Please let us know how we can improve our level of communication, accessibility, professionalism and interaction to receive a “Perfect” score. (optional)'
                },
                service_modules: [
                    { value: 'contingency', text: 'Contingency Plan'},
                    { value: 'deal-support', text: 'Deal Support'},
                    { value: 'employee2owner', text: 'Employee Ownership Plan'},
                    { value: 'employment-resources', text: 'Employment Resources'},
                    { value: 'entity-support', text: 'Entity Support'},
                    { value: 'equity', text: 'Equity Appreciation Rights Plan'},
                    { value: 'offer-letter', text: 'Offer Letter'},
                    { value: 'private-consulting', text: 'Private Consulting'},
                    { value: 'merger', text: 'Merger'},
                    { value: 'seller-advocacy', text: 'Seller Advocacy'},
                    { value: 'succession', text: 'Succession Blueprint'},
                    { value: 'valuation', text: 'Valuation'}
                ],
                referral_list: [
                    'SRG Blog/Website',
                    'Google/Bing/Yahoo Search Engine',
                    'Broker-Dealer/Custodian Referral',
                    'Lender Referral',
                    'Past Client Referral',
                    'Conference(s)',
                    'Social Media'
                ],
                surveydata: {
                    timeliness: '',
                    timeliness_feedback: '',
                    professionalism: '',
                    professionalism_feedback: '',
                    fees: '',
                    recommend: '',
                    learn: '',
                    comments_feedback: '',
                    permission: false,
                    reference: false,
                    client_name: '',
                    module_name: ''
                }
            }
        },

        methods: {

            surveyAnswers: function () {
                this.$refs.form.validate();
                if ( this.valid ) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    
                    this.$emit( 'submitSurvey', this.surveydata );
                }
            },

            serviceTeam: function () {
                this.$emit( 'getServiceTeam', this.surveydata.module_name ) 
            },
            
            
            clearSurvey () {
                this.$refs.form.reset()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .form_wrapper {
        margin: 0 auto; 
        padding: 0;
        background-color:#EFEFEF;
    }
    .survey {
        font-size: 1rem;
        background-color:#EFEFEF;
    }
</style>


// WEBPACK FOOTER //
// src/components/surveys/HowDidWeDo.vue